// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"AssetCard__Wrapper_H1LYH","Factoid":"AssetCard__Factoid_3HOny","FactoidTitle":"AssetCard__FactoidTitle_38t_M","FactoidText":"AssetCard__FactoidText_oGVkE"};